/*
 * @Autor: Hongting Yuan
 * @Date: 2021-11-30 09:10:25
 * @LastEditors: Haiting Zhao
 * @LastEditTime: 2021-12-19 12:52:34
 * @Description: 封装限流函数
 * @FilePath: \Management-of-Scientific-Research-in-Universities-Front\src\assets\js\preventReClick.js
 */
// import { Message } from 'element-ui'

// import { ajax } from 'jquery'

export default {

  install(Vue) {
    // 防止重复点击

    Vue.directive('preventReClick', {
      inserted(el, binding) {
        // console.log('binding-7', binding)
        el.addEventListener('click', (event) => {
          // 节流
          // console.log(event)
          // console.log(el)
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 1000)
          }
        })
      }

    })
  }

}
